export const OZMO_BASE_URL = "https://asurion-support.sds.modeaondemand.com/";
